<template>
<main class="main">
    <section class="section banner banner-section">
        <div :class="`container banner-column ${this._key % 2 == 0 ? 'banner-column-reverse' : ''}`">
            <img class="banner-image" :src="require(`@/assets/img/ranking/${token.symbol}-logo.png`)" style="width: 200px;" alt="banner">
            <div class="banner-inner">
                <h1 class="heading-xl">{{ $t(`lang.${token.symbol}Header`) }}</h1>
                <p class="paragraph">{{ $t(`lang.${token.symbol}Paragraph`) }}</p>
                <!--<button class="btn btn-darken btn-inline">
                Our Products<i class="bx bx-right-arrow-alt"></i>
                </button>-->
            </div>
            <div class="banner-links">
                <img :src="require('@/assets/img/telegram.svg')" @click="handleClick('https://t.me/revolutionNFT')" />
                <img :src="require('@/assets/img/social02.svg')" @click="handleClick('https://twitter.com/NFTRevo')" />
                <img :src="require('@/assets/img/reddit.svg')" @click="handleClick('https://www.reddit.com/r/RevoNFT/')" />
            </div>
        </div>
    </section>
</main>
</template>

<script>
export default {
    props: {
        _key: Number,
        token: Object
    },
    created() {
        this.lang = sessionStorage.getItem("Language");
    },
    methods: {
    handleClick(src){
        if(src){
          window.open(src);
        }
    }
  },
}
</script>

<style lang='less' scoped>
*, *::before, *::after {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    list-style: none;
    list-style-type: none;
    text-decoration: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
}
html {
    font-size: 100%;
    box-sizing: inherit;
    scroll-behavior: smooth;
    height: -webkit-fill-available;
}
body {
    font-family: "Rubik", sans-serif;
    font-size: clamp(1rem, 2vw, 1.125rem);
    font-weight: 400;
    line-height: 1.5;
    height: -webkit-fill-available;
    color: #fff;
    background-color: #080a0c;
}
main {
    overflow: hidden;
}
a, button {
    cursor: pointer;
    border: none;
    outline: none;
    user-select: none;
    background: none;
    box-shadow: none;
    text-decoration: none;
}
img, video {
    display: block;
    max-width: 100%;
    height: auto;
    object-fit: cover;
}
.section {
    margin: 0 auto;
    padding: 3rem 0 3rem;
}
.container {
    max-width: 75rem;
    height: auto;
    margin: 0 auto;
    padding: 0 1.25rem;
}
.centered {
    text-align: center;
    vertical-align: middle;
    margin-bottom: 1rem;
}
.heading-xl {
    font-family: inherit;
    font-size: clamp(2.648rem, 6vw, 4.241rem);
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -1px;
}
.heading-lg {
    font-family: inherit;
    font-size: clamp(2.179rem, 5vw, 3.176rem);
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -1px;
}
.heading-md {
    font-family: inherit;
    font-size: clamp(1.794rem, 4vw, 2.379rem);
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -1px;
}
.heading-sm {
    font-family: inherit;
    font-size: clamp(1.476rem, 3vw, 1.782rem);
    font-weight: 600;
    line-height: 1.5;
}
.heading-xs {
    font-family: inherit;
    font-size: clamp(1.215rem, 2vw, 1.335rem);
    font-weight: 500;
    line-height: 1.5;
}
.paragraph {
    font-family: inherit;
    font-size: clamp(1rem, 2vw, 1.125rem);
    text-wrap: balance;
}
.btn {
    display: inline-block;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    user-select: none;
    outline: none;
    border: none;
    border-radius: 0.25rem;
    text-transform: unset;
    transition: all 0.3s ease-in-out;
}
.btn-inline {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.5rem;
}
.btn-darken {
    padding: 0.75rem 2rem;
    color: white;
    background-color: #bedbfe;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.btn-neutral {
    padding: 0.75rem 2rem;
    color: #080a0c;
    background-color: #fff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: auto;
    margin: 0 auto;
    transition: all 0.35s ease;
}
.header.on-scroll {
    background: #0c0f13;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.navbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 1.25rem;
    width: 100%;
    height: 4.25rem;
    margin: 0 auto;
}
.brand {
    font-family: inherit;
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: -1px;
    color: #fff;
    text-transform: uppercase;
}
.menu {
    position: fixed;
    top: -100%;
    left: 0;
    width: 100%;
    height: auto;
    padding: 4rem 0 3rem;
    overflow: hidden;
    background-color: #0c0f13;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transition: all 0.4s ease-in-out;
}
.menu.is-active {
    top: 0;
    width: 100%;
    height: auto;
}
.menu-inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 1.25rem;
}
.menu-link {
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: #fff;
    text-transform: uppercase;
    transition: all 0.3s ease;
}
.menu-block {
    display: inline-block;
    font-family: inherit;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25;
    user-select: none;
    white-space: nowrap;
    text-align: center;
    margin-left: auto;
    padding: 0.65rem 1.5rem;
    border-radius: 3rem;
    text-transform: capitalize;
    color: white;
    background-color: #2463eb;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease-in-out;
}
@media only screen and (min-width: 48rem) {
    .menu {
        position: relative;
        top: 0;
        width: auto;
        height: auto;
        padding: 0rem;
        margin-left: auto;
        background: none;
        box-shadow: none;
}
    .menu-inner {
        display: flex;
        flex-direction: row;
        column-gap: 2rem;
        margin: 0 auto;
}
    .menu-link {
        text-transform: capitalize;
}
    .menu-block {
        margin-left: 2rem;
}
}
.burger {
    position: relative;
    display: block;
    cursor: pointer;
    user-select: none;
    order: -1;
    z-index: 10;
    width: 1.6rem;
    height: 1.15rem;
    border: none;
    outline: none;
    background: none;
    visibility: visible;
    transform: rotate(0deg);
    transition: 0.35s ease;
}
@media only screen and (min-width: 48rem) {
    .burger {
        display: none;
        visibility: hidden;
}
}
.burger-line {
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    height: 2px;
    border: none;
    outline: none;
    opacity: 1;
    border-radius: 1rem;
    transform: rotate(0deg);
    background-color: #fff;
    transition: 0.25s ease-in-out;
}
.burger-line:nth-child(1) {
    top: 0px;
}
.burger-line:nth-child(2) {
    top: 0.5rem;
    width: 70%;
}
.burger-line:nth-child(3) {
    top: 1rem;
}
.burger.is-active .burger-line:nth-child(1) {
    top: 0.5rem;
    transform: rotate(135deg);
}
.burger.is-active .burger-line:nth-child(2) {
    opacity: 0;
    visibility: hidden;
}
.burger.is-active .burger-line:nth-child(3) {
    top: 0.5rem;
    transform: rotate(-135deg);
}
.banner-column {
    position: relative;
    display: grid;
    align-items: center;
    row-gap: 3rem;
}
.banner-column-reverse {
grid-auto-flow: dense;
direction: rtl;
}
@media only screen and (min-width: 48rem) {
    .banner-column {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        justify-content: center;
}
}
@media only screen and (min-width: 64rem) {
    .banner-column {
        grid-template-columns: 1fr max-content;
        column-gap: 4rem;
        margin-top: 3rem;
}
}
.banner-image {
    display: block;
    max-width: 18rem;
    height: auto;
    margin-top: 2rem;
    object-fit: cover;
    justify-self: center;
}
@media only screen and (min-width: 48rem) {
    .banner-image {
        order: 1;
        max-width: 20rem;
        height: auto;
}
}
@media only screen and (min-width: 64rem) {
    .banner-image {
        max-width: 25rem;
        height: auto;
        margin-right: 5rem;
}
}
.banner-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1.75rem;
    text-align: center;
}
.banner-links {
    position: absolute;
    top: 30%;
    right: 1.5rem;
    display: grid;
    justify-items: center;
    row-gap: 0.5rem;
    opacity: 1;
    visibility: hidden;
}
@media only screen and (min-width: 64rem) {
    .banner-links {
        opacity: 1;
        visibility: hidden;
    }
    .banner-inner {
        text-align: start;
    }
}
.banner-links > * {
    font-size: 1.25rem;
    line-height: 1.25;
    color: black;
}
.banner-links::before {
    position: absolute;
    content: "";
    top: -3rem;
    width: 4rem;
    height: 1.5px;
    transform: rotate(90deg);
    background: white;
}
.banner-links::after {
    position: absolute;
    content: "";
    bottom: -3rem;
    width: 4rem;
    height: 2px;
    transform: rotate(90deg);
    background: white;
}
</style>